import { render, staticRenderFns } from "./UserImpersonationDialog.vue?vue&type=template&id=ba1a6512"
import script from "./UserImpersonationDialog.vue?vue&type=script&lang=js"
export * from "./UserImpersonationDialog.vue?vue&type=script&lang=js"
import style0 from "./UserImpersonationDialog.vue?vue&type=style&index=0&id=ba1a6512&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports